export default __webpack_public_path__ + "static/media/minting-completed-card-bg.6f39acca.png";